import React from "react";
import { motion } from "framer-motion";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/dYzital_logo.png";
import { fadeUp, staggerParent } from "./motion";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  return (
    <motion.nav
      className="navbar"
      variants={staggerParent(0.04, 0.07)}
      initial="hidden"
      animate="show"
    >
      <motion.div variants={fadeUp}>
        <Link to="/" className="logo-container brand-link" aria-label="Go to home page">
          <img src={logo} alt="dYzital logo" className="logo-img" />
          <span className="logo-text">dYzital</span>
        </Link>
      </motion.div>

      <motion.ul className="nav-links" variants={staggerParent(0.08, 0.06)}>
        {navItems.map((item) => (
          <motion.li key={item.to} variants={fadeUp}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                isActive ? "nav-link nav-link-active" : "nav-link"
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          </motion.li>
        ))}
        <motion.li variants={fadeUp} className="nav-cta-wrap">
          <Link to="/contact" className="nav-cta">
            Book Free Consultation
          </Link>
        </motion.li>
      </motion.ul>
    </motion.nav>
  );
};

export default Navbar;
